/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import SingleProduct from "../Component/Menu/SingleProduct";
import Layout from "../Component/Layout/Layout";
import TabArea from "../Component/Menu/TabArea.jsx";
import RelatedProduct from "../Component/Menu/RelatedProduct";
import { useLocation, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { axiosInstance } from "../Component/utils/axiosInstance.js";
import Loader from "../Component/Loader.jsx";

export const MenuDetail = () => {
  const location = useLocation();
  const id = useParams();
  const [url, setUrl] = useState("");
  const [loader, setloader] = useState(false);
  const [singleProductData, setSingleProductData] = useState(null);

  function Top() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }

  const getSingleProduct = async () => {
    setloader(true);
    try {
      await axiosInstance.get(`user/product/${id?.id}`).then((response) => {
        if (response?.data?.status === true) {
          Top();
          setSingleProductData(response?.data?.product);
          setloader(false);
        }
      });
    } catch (error) {
      setloader(false);
    }
  };
  const [allProduct, setAllProduct] = useState([]);
  const getAllProduct = async () => {
    setloader(true);
    try {
      await axiosInstance.get("user/product").then((response) => {
        if (response?.data?.status === true) {
          setloader(false);

          setAllProduct(response?.data?.products);
        }
      });
    } catch (error) {
      setloader(false);
    }
  };

  useEffect(() => {
    getAllProduct();
  }, []);

  useEffect(() => {
    getSingleProduct();
  }, [id]);

  const [showModal, setShowModal] = useState(false);
  const handleClose = () => setShowModal(false);
  const handleShow = () => setShowModal(true);
  const urlToShare = window.location.href;

  return loader ? (
    <Loader />
  ) : (
    <Layout>
      <section className="menu_details mt_100 pt-5 xs_mt_75 mb_95 xs_mb_65">
        <div className="container">
          <SingleProduct
            urlToShare={url}
            handleShow={handleShow}
            handleClose={handleClose}
            showModal={showModal}
            productData={singleProductData}
          />
          <TabArea tabData={location?.state?.productData} />
          {/* <h2 className="text-black mt-4 mb-2">Description</h2>
          <div
            className="menu_det_description border-0 border-top border-danger"
            dangerouslySetInnerHTML={{
              __html: location?.state?.productData?.detail_description,
            }}
          ></div> */}
          <RelatedProduct
            setUrl={setUrl}
            setShowModal={setShowModal}
            productData={allProduct}
          />
        </div>
      </section>
    </Layout>
  );
};
